import { generateTypes, promisify } from "../../../utilities";
import SuperTableShim from "../../common/SuperTableShim";

import { RS } from "../../../data/strings/global";
import * as SC from "../../../data/strings/PIStringConst";

import * as gbtu from "../../GB/GBTableUtil";
import * as piasu from "../NonComponents/PIAppStateUtil";
import * as pisc from "../NonComponents/PIServerConst";
import * as gbtc from "../../GB/GBTableConst";

import * as Theme from "../../../app/Theme";

import { combinePriorPops, disaggregatePriorPops, genAndKeyPopsCombinedPops } from "../NonComponents/PIPriorPopUtil";

const methodNameCol = 0;
const totalCol = 1;
const popColStart = 2;

const headerRow = 0;

const PICostCatMethodAboveSiteByPopTable = (props) => {
  const { modVarObjList, onModVarsChange } = props;

  const isPSEMode = piasu.isPSEMode(modVarObjList);

  const methodObjArr = piasu.getModVarValue(modVarObjList, pisc.methodsMVTag);
  const numMethods = piasu.getTotalNumMethods(methodObjArr);

  let combined;
  let priorPops = piasu.getModVarValue(modVarObjList, pisc.priorPopsMVTag);
  let eligibility = piasu.getModVarValue(modVarObjList, pisc.priorPopMethodEligMVTag);
  let costCatLite = piasu.getModVarValue(modVarObjList, pisc.costCategoriesLiteMVTag);

  if (isPSEMode) {
    combined = combinePriorPops(modVarObjList, genAndKeyPopsCombinedPops, ["PI_Eligibility", "PI_CostCategories_Lite"]);
    priorPops = combined["PI_PriorityPop"];
    eligibility = combined["PI_Eligibility"];
    costCatLite = combined["PI_CostCategories_Lite"];
  }

  const onPackTableChange = async (newPackTable) => {
    const onModVarsChangeAync = promisify(onModVarsChange);
    const newModVars = structuredClone(modVarObjList);

    const newData = {
      PI_PriorityPop: priorPops,
      PI_CostCategories_Lite: structuredClone(costCatLite),
    };

    let row = 1;
    for (const method of methodObjArr) {
      let col = popColStart;
      const methodID = method.mstID;
      for (let pp = 1; pp <= newData.PI_PriorityPop.length; ++pp) {
        if (piasu.getPriorPopMethodElig(eligibility, methodID, pp) === pisc.yesCVOMstID) {
          const annLumpSumCost = gbtu.getValue(newPackTable, row, col);
          piasu.setAnnLumpSumCostsLite(methodID, newData.PI_CostCategories_Lite, pp, annLumpSumCost);
        }
        col++;
      }
      row++;
    }

    if (isPSEMode) {
      const disagg = disaggregatePriorPops(modVarObjList, newData, genAndKeyPopsCombinedPops);
      piasu.setModVarValue(newModVars, pisc.costCategoriesLiteMVTag, disagg.PI_CostCategories_Lite);
    } else {
      piasu.setModVarValue(newModVars, pisc.costCategoriesLiteMVTag, newData.PI_CostCategories_Lite);
    }

    await onModVarsChangeAync(newModVars, false);
  };

  // Table
  const numRows = numMethods + 1;
  const numCols = priorPops.length + 2;
  const packTable = gbtu.resizePackTable(gbtu.getNewPackTable(), numRows, numCols);

  gbtu.setValue(packTable, headerRow, methodNameCol, RS(SC.GB_stMethod));
  gbtu.setRowAlignment(packTable, headerRow, gbtc.hAlign.center);
  gbtu.setMaxAllowedValForTable(packTable, gbtc.maxInt);

  gbtu.setColWidth(packTable, totalCol, Theme.dataColWidthMed);
  gbtu.setValue(packTable, headerRow, totalCol, RS(SC.GB_stTotal));
  gbtu.lockCol(packTable, totalCol, true);

  for (let m = 0; m < numMethods; m++) {
    const method = methodObjArr[m];
    gbtu.setValue(packTable, m + 1, methodNameCol, method.name);
  }

  let col = popColStart;
  for (let pp = 1; pp <= priorPops.length; pp++) {
    const priorPopName = piasu.getPriorPopName(priorPops, pp);
    gbtu.setValue(packTable, 0, col, priorPopName);
    gbtu.setColWidth(packTable, col, Theme.dataColWidthMed);
    col++;
  }

  let row = 1;
  for (const method of methodObjArr) {
    let col = popColStart;
    const methodID = method.mstID;
    for (let pp = 1; pp <= priorPops.length; pp++) {
      const methodEligMstIDStr = piasu.getPriorPopMethodElig(eligibility, methodID, pp);
      if (methodEligMstIDStr === pisc.yesCVOMstID) {
        const annLumpSumCost = piasu.getAnnLumpSumCostsLite(methodID, costCatLite, pp);
        gbtu.setValue(packTable, row, col, annLumpSumCost);
      } else {
        gbtu.lockCell(packTable, row, col, true, true);
        gbtu.setCellBGColor(packTable, row, col, Theme.whisperGrayTableColor);
      }
      col++;
    }
    row++;
  }

  const fillTotals = (packTable) => {
    console.log({ packTable });
    for (let row = 1; row < packTable.GBRowCount; row++) {
      const sum = packTable.tableData.value[row]
        .slice(popColStart)
        .filter((x) => typeof x === "number")
        .reduce((acc, cur) => acc + cur, 0);
      gbtu.setValue(packTable, row, totalCol, sum);
    }
  };

  fillTotals(packTable);

  const types = generateTypes(packTable);

  return <SuperTableShim packTable={packTable} types={types} onPackTableChanged={onPackTableChange} />;
};

export default PICostCatMethodAboveSiteByPopTable;
